import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Bell } from 'lucide-react';
import { useNotifications } from '../../contexts/NotificationsContext';
import Drawer from '../common/Drawer';
import Button from '../common/Button';
import EmptyState from '../common/EmptyState';
import { formatRelativeTime } from '../../utils/formatRelativeTime';

const NotificationBell = () => {
  const { items, unreadCount, markAsRead, markAllAsRead } = useNotifications();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const handleClick = async (notification) => {
    if (!notification.readAt) await markAsRead(notification.id);
    if (notification.link) {
      setOpen(false);
      navigate(notification.link);
    }
  };

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="relative p-2 rounded-md text-app-text-secondary hover:bg-app-surface-hover transition-colors"
        aria-label={`Notificações${unreadCount ? ` (${unreadCount} não lidas)` : ''}`}
      >
        <Bell size={18} />
        {unreadCount > 0 && (
          <span className="absolute top-1 right-1 w-4 h-4 rounded-full bg-error text-white text-[10px] font-bold flex items-center justify-center">
            {unreadCount > 9 ? '9+' : unreadCount}
          </span>
        )}
      </button>

      <Drawer
        open={open}
        onClose={() => setOpen(false)}
        title="Notificações"
        side="right"
        size="md"
        footer={
          unreadCount > 0 && (
            <Button size="sm" variant="subtle" fullWidth onClick={markAllAsRead}>
              Marcar todas como lidas
            </Button>
          )
        }
      >
        {items.length === 0 ? (
          <EmptyState
            icon={Bell}
            title="Sem notificações"
            description="Você receberá um aviso aqui quando houver algo novo."
          />
        ) : (
          <ul className="divide-y divide-app-border">
            {items.map((n) => (
              <li key={n.id}>
                <button
                  type="button"
                  onClick={() => handleClick(n)}
                  className={`w-full p-4 text-left transition-colors ${
                    n.readAt ? 'hover:bg-app-surface-hover' : 'bg-primary/5 hover:bg-primary/10'
                  }`}
                >
                  <div className="flex items-start gap-2 mb-1">
                    {!n.readAt && <span className="w-2 h-2 rounded-full bg-primary mt-2 flex-shrink-0" />}
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-semibold text-app-text">{n.title}</p>
                      {n.message && (
                        <p className="text-sm text-app-text-secondary mt-0.5">{n.message}</p>
                      )}
                      <p className="text-xs text-app-text-secondary mt-1">
                        {formatRelativeTime(n.createdAt)}
                      </p>
                    </div>
                  </div>
                </button>
              </li>
            ))}
          </ul>
        )}
      </Drawer>
    </>
  );
};

export default NotificationBell;
